import { QteNoteDef } from '../../types/note/note.def';
import softSkillsCalcul from './softSkillsCalcul';
import { GraphRadarValue } from '../../components/molecules/Charts/GraphRadar';

export const mesComptencesFields = (notes: QteNoteDef): GraphRadarValue[] => [
  {
    type: 'Implication',
    niveau: softSkillsCalcul.implication(notes.qtevente),
    emoji: 'Handshake'
  },
  {
    type: 'Adaptation aux consignes',
    niveau: softSkillsCalcul.adaptConsigne(notes.qterebond),
    emoji: 'GradutationCap'
  },
  {
    type: 'Dépassement de soi',
    niveau: softSkillsCalcul.depassementSoi(notes.qteca),
    emoji: 'BriefCase'
  },
  {
    type: "Curiosité, envie d'apprendre",
    niveau: softSkillsCalcul.curiosite(notes.qtequiz),
    emoji: 'SportsMedal'
  },
  {
    type: 'Négocier en B to C',
    niveau: softSkillsCalcul.btoc(notes.qtevente, notes.qtepro),
    emoji: 'CheckBoxWithCheck'
  },
  {
    type: 'Négocier en B to B',
    niveau: softSkillsCalcul.btob(notes.qtepro),
    emoji: 'FlexedBiceps'
  }
];
